<template>
  <div id="TripList" class="container">
    <p v-if="trips.length < 1">No created trips to yet</p>
    <div v-else class="card-deck">
      <div
        class="card border-info mb-3"
        style="max-width: 15rem;"
        v-for="trip in trips"
        :key="trip.id"
      >
        <div class="card-header">
          <p>Number Plate: {{ trip.vehicle_plate }}</p>
          <p>Trip Code: {{ trip.trip_code }}</p>
        </div>
        <div class="card-body text-info">
          <p class="card-text">
            From: <span>{{ trip.current_location }}</span>
          </p>
          <p class="card-text">
            Destination: <span>{{ trip.destination_location }}</span>
          </p>
          <p class="card-text">
            Status:
            <span
              class="badge badge-pill"
              v-bind:class="{
                'badge-success': trip.is_active === true,
                'badge-warning': trip.is_active === false,
              }"
            >
              {{ trip.is_active }}
            </span>
          </p>
          <div class="d-flex justify-content-end">
            <a href="#" class="btn btn-outline-info">Trip Details</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TripList",
  // props: {
  //     trips: Array
  // },
  data() {
    return {
      trips: [],
    };
  },
  mounted() {
    this.getTrips();
  },
  methods: {
    async getTrips() {
      try {
        const response = await fetch("https://expan-one-lfw4jdwenq-ew.a.run.app/gateway/api/v1/trip/");
        const data = await response.json();
        this.trips = data.data;
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style></style>
